import { combineReducers } from "redux";
import App from './App/Reducer';

export default combineReducers({
    App,
});